import { selectGlobalSettings, useSelector } from '@oneview/redux';
import { selectBaseCurrency } from '@oneview/redux/misc/miscSelectors';

export function useCurrentBaseCurrency() {
    const { defaultBaseCurrency } = useSelector(selectGlobalSettings);
    const baseCurrency = useSelector(selectBaseCurrency);

    return baseCurrency || defaultBaseCurrency;
}
